const SITE_ORIGIN = 'https://mycompanyplus.com'
const DEFAULT_DESCRIPTION =
  'MyCo+ (product of MyCompany+) is the operations platform for forms, jobs, inventory, safety, HR, and maintenance—connect your company, your way.'
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/images/mycoAssets/logos/logo.png`

function ensureMeta(attr, key, content) {
  if (typeof document === 'undefined') return
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function ensureLink(rel, href) {
  if (typeof document === 'undefined') return
  let el = document.head.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * Apply public / marketing document head from route.meta.pageMeta.
 * Authenticated app routes leave title to documentTitle.js ({company} | MyCo+).
 */
export function applyRoutePageMeta(route) {
  if (typeof document === 'undefined') return

  const meta = route?.meta?.pageMeta
  if (!meta) {
    document.documentElement.dataset.pageMetaOwned = ''
    return
  }

  document.documentElement.dataset.pageMetaOwned = '1'

  if (meta.title) {
    document.title = meta.title
  }

  const description = meta.description || DEFAULT_DESCRIPTION
  const robots = meta.robots || 'index, follow'
  const canonical = meta.canonical || `${SITE_ORIGIN}${route.path === '/' ? '/' : route.path}`
  const ogTitle = meta.ogTitle || meta.title || 'MyCo+'
  const ogImage = meta.ogImage || DEFAULT_OG_IMAGE

  ensureMeta('name', 'description', description)
  ensureMeta('name', 'robots', robots)
  ensureLink('canonical', canonical)

  ensureMeta('property', 'og:type', 'website')
  ensureMeta('property', 'og:site_name', 'MyCo+')
  ensureMeta('property', 'og:title', ogTitle)
  ensureMeta('property', 'og:description', description)
  ensureMeta('property', 'og:url', canonical)
  ensureMeta('property', 'og:image', ogImage)
  ensureMeta('property', 'og:image:alt', 'MyCo+ logo')

  ensureMeta('name', 'twitter:card', 'summary')
  ensureMeta('name', 'twitter:title', ogTitle)
  ensureMeta('name', 'twitter:description', description)
  ensureMeta('name', 'twitter:image', ogImage)
}

export function pageMetaOwnsTitle() {
  return typeof document !== 'undefined' && document.documentElement.dataset.pageMetaOwned === '1'
}

export { SITE_ORIGIN, DEFAULT_DESCRIPTION, DEFAULT_OG_IMAGE }
